import { render } from "./CreateAdminForm.vue?vue&type=template&id=457adbcc&scoped=true"
import script from "./CreateAdminForm.vue?vue&type=script&lang=js"
export * from "./CreateAdminForm.vue?vue&type=script&lang=js"

import "./CreateAdminForm.vue?vue&type=style&index=0&id=457adbcc&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457adbcc"]])

export default __exports__